import { Box, Card, Typography } from '@mui/material';
import { styled } from '@mui/system';
import WolfSectionColor from '@components/ui/WolfSectionColor';

interface SettingCardProps {
  title: string;
  icon?: React.ReactNode;
  iconColor?: string;
  children: React.ReactNode;
  className?: string;
}

const StyledCard = styled(Card)(({ theme }) => ({
  transition: 'border 0.3s',
  border: '1px solid ' + theme.palette.primaryFrozen.main,
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
  '&:hover': {
    border: `2px solid ${theme.palette.primaryIcy.main}`,
    boxShadow: 'none',
  },
}));

const SettingCard: React.FC<SettingCardProps> = ({ title, icon, iconColor, children, className }) => {
  return (
    <StyledCard className={className}>
      <Box className="p-6">
        {/* Header with icon and title */}
        <Box className="flex items-center gap-3 mb-4">
          {icon && iconColor && <WolfSectionColor color={iconColor} icon={icon} />}
          <Typography variant="h4semibold">{title}</Typography>
        </Box>

        {/* Content */}
        <Box>{children}</Box>
      </Box>
    </StyledCard>
  );
};

export default SettingCard;
